import { useTranslation } from 'react-i18next';
import React, { memo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'clsx';

import { IconRcStreamEditorButton } from '@/assets/stream';
import { Button } from '@/components';
import { suicideToast } from '@/components/SystemErrorToast';
import { useCurrentAddressInfo } from '@/hooks';
import { login } from '@/utils';

import { CLEAR_BACK_STATE } from '../../const';
import style from './index.module.scss';

type Props = { className?: string; hideText?: boolean; onClick?: () => void };

export const StreamOpenEditorButton = memo(({ className, hideText, onClick }: Props) => {
  const { t } = useTranslation();
  const { address, isVerified, userInfo } = useCurrentAddressInfo();
  const history = useHistory();
  const handleClick = useCallback(() => {
    onClick?.();
    if (!address || !isVerified) {
      login();
      return;
    }

    if (userInfo?.is_suicide) {
      suicideToast();
      return;
    }

    history.push('/new-stream', CLEAR_BACK_STATE);
  }, [address, history, isVerified, onClick, userInfo?.is_suicide]);

  return (
    <Button
      type="primary"
      ghost
      onClick={handleClick}
      className={cx(style.editorButton, className)}>
      <IconRcStreamEditorButton height={24} width={24} />
      {hideText ? null : t('StreamEditorModal.mv8mlc')}
    </Button>
  );
});
